<template>
  <div class="h-full">
    <ui-nav-menu>
      <a href="/overview" rel="home" @click="navigate">Home</a>
      <a
        v-for="link in navigationLinks"
        :key="link.destination"
        :href="link.destination"
        @click="navigate"
        >{{ link.label }}</a
      >
    </ui-nav-menu>
    <router-view />
    <Notification
      v-if="loadNotification"
      :text="notificationText"
      :show="showNotification"
    />
  </div>
</template>
<script>
import Notification from "./components/Common/Notification.vue";

export default {
  components: {
    Notification
  },
  data() {
    return {
      notificationText: "",
      showNotification: false,
      loadNotification: false,
      navigationLinks: [
        {
          label: "Abandoned carts",
          destination: "/carts"
        },
        {
          label: "Chat & Share",
          destination: "/chat"
        },
        {
          label: "Automation",
          destination: "/automation"
        },
        {
          label: "Orders",
          destination: "/orders"
        },
        {
          label: "Plans & Settings",
          destination: "/settings"
        },
        {
          label: "Team Inbox",
          destination: "/inbox"
        },
        // {
        //   label: "Marketing",
        //   destination: "/marketing"
        // },
        {
          label: "Marketing & Upsells",
          destination: "/marketingandupsells"
        }
      ]
    };
  },
  mounted() {
    setTimeout(() => {
      this.loadNotification = true;
    }, 3000);
  },
  created() {
    this.$store.dispatch("initAppBridge").then(app => {
      this.subscribeToNavRedirect(app);
    });
    window.addEventListener("ToastNotify", event => {
      this.displayNotification(event.detail.text);
    });
  },
  methods: {
    subscribeToNavRedirect() {
      // if (app) {
      console.log("app location", location);
      console.log("routename", this.$route.name);
      if (location.pathname && location.pathname != "/") {
        if (location.pathname.indexOf("/api/shopify/connect") > -1) {
          this.$router.push({ path: "/overview" });
        } else {
          this.$router.push({ path: location.pathname });
        }
      }

      // app.subscribe(Redirect.Action.APP, redirectData => {
      //   console.log(redirectData.path); // For example, '/settings'
      //   if (redirectData.path.indexOf("/api/shopify/connect") > -1) {
      //     this.$router.push({ path: "/overview" });
      //   } else {
      //     this.$router.push({ path: redirectData.path });
      //   }
      // });
      // }
    },
    navigate(event) {
      event.preventDefault();
      history.pushState({}, null, event.target.href);
      this.$router.push({ path: event.target.pathname });
    },
    displayNotification(text) {
      this.showNotification = true;
      this.notificationText = text;
      setTimeout(() => {
        this.showNotification = false;
      }, 3000);
    }
  }
};
</script>

<style>
ui-nav-menu a {
  display: none;
}
</style>
